module.exports = __webpack_public_path__ + "static/Javiera-Light-65806d65122dba23b69b0cb4adbfe49b.woff";